import React from 'react';

import Helmet from 'wanderu-component-helmet';
import { localize } from 'wanderu-i18n';

import tcConfig from '../../config/termsandconditions.locale';

function TermsAndConditionsMeta(props) {
    const {
        t,
        ...otherProps
    } = props;

    const title = t('metaPageTitle');
    const description = t('metaPageDescription');

    return (
        <Helmet
            {...otherProps}
            description={description}
            supportedLocales={tcConfig.supportedLocales}
            title={title}
        />
    );
}

export { TermsAndConditionsMeta };
export default localize(TermsAndConditionsMeta, tcConfig.namespace);
